import { createSelector } from 'reselect';
import { getDeepValue } from 'ContentUtils/helpers/ObjectHelpers';
const getValidationErrors = state => state.resources.validationErrors;
const getFieldKeyFromProps = (state, props) => props.fieldKey;
export const makeGetHasValidationError = () => {
  return createSelector([getValidationErrors, getFieldKeyFromProps], (validationErrors, fieldKey) => {
    return !!getDeepValue(validationErrors, fieldKey);
  });
};
export const makeGetValidationErrorIndexes = () => {
  return createSelector([getValidationErrors, getFieldKeyFromProps], (validationErrors, fieldKey) => {
    const errors = getDeepValue(validationErrors, fieldKey);
    if (errors && Array.isArray(errors)) {
      //filter out null placeholder values in error array so we only return indexes where error = true
      return errors.reduce((hash, error, index) => /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
      error ? [...hash, index] : hash, []);
    } else return [];
  });
};